/* GENERATED by scripts/gen-data.mjs — chapter "x-drift" (from s2.js + s3.js).
 * Structure only: every string is an i18n key resolved from
 * src/i18n/locales/<lang>/. Edit the content in the artifact and re-run
 * npm run extract, do not hand-edit here. */

import type { NodeDef } from '../../types';

export const N_X_DRIFT: NodeDef = {
  "id": "x-drift",
  "tagKey": "path:x-drift.tag",
  "x": 96,
  "y": 700,
  "w": 176,
  "h": 88,
  "titleKey": "path:x-drift.title",
  "subKey": "path:x-drift.sub",
  "blocks": [
    {
      "id": "x-drift.b1",
      "kind": "explain",
      "xp": 15,
      "titleKey": "path:x-drift.b1.title",
      "bodyKey": "path:x-drift.b1.body",
      "flowKey": "path:x-drift.b1.flow",
      "read": [
        "drift"
      ]
    },
    {
      "id": "x-drift.b2",
      "kind": "film",
      "xp": 25,
      "titleKey": "path:x-drift.b2.title",
      "film": "f-drift"
    },
    {
      "id": "x-drift.b3",
      "kind": "check",
      "xp": 30,
      "titleKey": "path:x-drift.b3.title",
      "ex": {
        "type": "classify",
        "binsKey": "path:x-drift.b3.ex.bins",
        "binCount": 2,
        "items": [
          {
            "tKey": "path:x-drift.b3.ex.items.0.t",
            "bin": 0,
            "whyKey": "path:x-drift.b3.ex.items.0.why"
          },
          {
            "tKey": "path:x-drift.b3.ex.items.1.t",
            "bin": 1,
            "whyKey": "path:x-drift.b3.ex.items.1.why"
          },
          {
            "tKey": "path:x-drift.b3.ex.items.2.t",
            "bin": 0,
            "whyKey": "path:x-drift.b3.ex.items.2.why"
          },
          {
            "tKey": "path:x-drift.b3.ex.items.3.t",
            "bin": 1,
            "whyKey": "path:x-drift.b3.ex.items.3.why"
          }
        ]
      }
    }
  ],
  "extra": true,
  "parent": "evaluate"
};
